import "../static/lowerbody.css";
import React, { useState, useEffect } from "react";
import ArtistList from "./ArtistsList";
import { fetchUsers } from "../../../firebase/users";
import { fetchArtists } from "../../../firebase/artists";

import { useHistory, withRouter, Link } from "react-router-dom";

function LowerBody() {
  let history = useHistory();

  const redirect = () => {
    history.push("/artist");
  };
  const [usersList, setusersList] = useState([]);
  const [artistsList, setartistsList] = useState([]);

  useEffect(() => {
    fetchUsers()
      .then((data) => setusersList(data))
      .catch(alert);
  }, []);

  useEffect(() => {
    if (!usersList.length) return;
    fetchArtists(usersList)
      .then((data) => setartistsList(data))
      .catch(alert);
  }, [usersList]);

  // const fetchArtists = async () => {
  //   let responseList = [];
  //   const response = db.collection(WEBSITE_USERS)
  //   const data = await response.get();
  //   data.docs.forEach((item) => {
  //     responseList.push(item.data());
  //   });

  //   setartistList(responseList);
  // };
  return (
    <div className="pb-xl-5 pb-lg-5 pb-md-5 bg-light-blue">
      <div className="listenToText2 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 mb-xl-5 mb-lg-5 mb-md-5 mb-sm-3 mb-3 px-xl-5 px-lg-5 px-md-5 ">
        Artists start Career with Ombré
      </div>
      <div className="container-fluid bodyDescriptionCard p-0">
        <div className="row p-0">
          <div className="row artboardImage col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">
            <div className="row p-0 justify-content-center align-self-center">
              <div className="artboardTextMobile d-md-none col-md-4 col-sm-6 col-6 text-center m-auto">
                Ombré for Artists
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 p-0 mx-xl-auto ml-lg-auto m-md-auto m-sm-auto m-auto">
            <div className="row p-0 justify-content-center align-self-center ">
              <div className="curatedHeading font-white col-xl-8 col-lg-8 col-md-8 mx-auto text-start d-none d-xl-block d-lg-block d-md-block">
                Ombré for Artists
              </div>
              <div className="curatedDescription text-start col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 mx-xl-auto mt-xl-4 mx-lg-auto mt-lg-4 mx-md-auto mt-md-4 mt-sm-5 mb-sm-4 mt-5 mb-2">
                Earn and grow fanbase with the power of Live Streaming. Launch
                your Artist career with Ombré !
              </div>
              <div className="col-xl-12 col-lg-10 col-md-10 col-sm-12 col-12 mt-xl-5 mt-lg-5  mx-md-auto mt-md-5 mx-sm-auto mt-sm-4 mb-sm-5 mx-auto mt-4 mb-5">
                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12  text-center">
                  <Link to="/artist">
                    <button className="rounded-pill px-xl-5 px-lg-5 px-md-5 px-sm-4 px-4 learnMoreButton py-xl-2 py-lg-2 py-md-2 py-sm-2 py-2">
                      Learn More
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="listenToText2 col-12">Discover the Artist Community</div>
      <div className="d-flex mb-xl-3 mb-lg-3 mb-md-3 mb-sm-0 mb-0">
        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-8 col-8 upcomingEventsTitle px-xl-0 px-lg-0 px-md-0 px-sm-3 px-3 pt-sm-3 pt-3">
          OUR ARTISTS
        </div>
      </div>
      <ArtistList artists={artistsList} />
    </div>
  );
}

export default withRouter(LowerBody);



// WEBPACK FOOTER //
// ./src/pages/Home/components/LowerBody.jsx